import { render } from "./Recent_Activity.vue?vue&type=template&id=2fad5b4e&scoped=true"
import script from "./Recent_Activity.vue?vue&type=script&lang=js"
export * from "./Recent_Activity.vue?vue&type=script&lang=js"

import "./Recent_Activity.vue?vue&type=style&index=0&id=2fad5b4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fad5b4e"]])

export default __exports__